import React from 'react';

const UserManagementHeader = ({ 
  onCreateUser, 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  roleFilter,
  setRoleFilter,
  totalUsers,
  filteredUsers
}) => {
  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        {/* Header principal con título y botón crear */}
        <div className="row align-items-center mb-4">
          <div className="col-md-8">
            <h1 className="h2 mb-1">
              <i className="bi bi-people me-2 text-primary"></i>
              Gestión de Usuarios
            </h1>
            <p className="text-muted mb-0">
              Administra todos los usuarios del sistema
              {totalUsers > 0 && (
                <span className="ms-2">
                  {filteredUsers !== totalUsers ? (
                    <span className="filter-results-indicator">
                      {filteredUsers} de {totalUsers} usuarios
                    </span>
                  ) : (
                    <span className="text-muted">
                      ({totalUsers} usuarios)
                    </span>
                  )}
                </span>
              )}
            </p>
          </div>
          <div className="col-md-4 text-end">
            <button
              onClick={onCreateUser}
              className="btn btn-primary"
            >
              <i className="bi bi-plus-circle me-2"></i>
              Crear Nuevo Usuario
            </button>
          </div>
        </div>

        {/* Sección de filtros integrada */}
        <div className="border-top pt-3">
          <div className="row g-3 align-items-end">
            {/* Barra de búsqueda */}
            <div className="col-md-5">
              <label className="form-label small text-muted mb-1">
                <i className="bi bi-search me-1"></i>
                Buscar usuarios
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control user-search-input"
                  placeholder="Nombre o email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setSearchTerm('')}
                    title="Limpiar búsqueda"
                  >
                    <i className="bi bi-x"></i>
                  </button>
                )}
              </div>
            </div>

            {/* Filtro por estado */}
            <div className="col-md-2">
              <label className="form-label small text-muted mb-1">
                <i className="bi bi-toggle-on me-1"></i>
                Estado
              </label>
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">Todos</option>
                <option value="active">Activos</option>
                <option value="inactive">Inactivos</option>
              </select>
            </div>

            {/* Filtro por rol */}
            <div className="col-md-2">
              <label className="form-label small text-muted mb-1">
                <i className="bi bi-person-badge me-1"></i>
                Rol
              </label>
              <select
                className="form-select"
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              >
                <option value="all">Todos</option>
                <option value="user">Usuarios</option>
                <option value="admin">Administradores</option>
              </select>
            </div>

            {/* Acciones de filtros */}
            <div className="col-md-3">
              <div className="d-flex justify-content-end align-items-center h-100">
                {(searchTerm || statusFilter !== 'active' || roleFilter !== 'all') && (
                  <button
                    className="btn btn-sm btn-outline-secondary filter-clear-btn"
                    onClick={() => {
                      setSearchTerm('');
                      setStatusFilter('active');
                      setRoleFilter('all');
                    }}
                    title="Restablecer filtros por defecto"
                  >
                    <i className="bi bi-arrow-clockwise me-1"></i>
                    Restablecer filtros
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Indicadores de filtros activos */}
          {(searchTerm || statusFilter !== 'active' || roleFilter !== 'all') && (
            <div className="mt-3 pt-2 border-top">
              <div className="d-flex flex-wrap gap-2 align-items-center">
                <small className="text-muted me-2">Filtros aplicados:</small>
                
                {searchTerm && (
                  <span className="badge bg-info">
                    <i className="bi bi-search me-1"></i>
                    "{searchTerm}"
                    <button 
                      className="btn-close btn-close-white ms-1" 
                      style={{fontSize: '0.6em'}}
                      onClick={() => setSearchTerm('')}
                    ></button>
                  </span>
                )}
                
                {statusFilter !== 'active' && (
                  <span className="badge bg-warning">
                    <i className="bi bi-toggle-on me-1"></i>
                    {statusFilter === 'all' ? 'Todos los estados' : statusFilter === 'inactive' ? 'Inactivos' : 'Activos'}
                    <button 
                      className="btn-close btn-close-white ms-1" 
                      style={{fontSize: '0.6em'}}
                      onClick={() => setStatusFilter('active')}
                    ></button>
                  </span>
                )}
                
                {roleFilter !== 'all' && (
                  <span className="badge bg-success">
                    <i className="bi bi-person-badge me-1"></i>
                    {roleFilter === 'user' ? 'Usuarios' : 'Administradores'}
                    <button 
                      className="btn-close btn-close-white ms-1" 
                      style={{fontSize: '0.6em'}}
                      onClick={() => setRoleFilter('all')}
                    ></button>
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserManagementHeader;
